export const removeNullProperties = (object: object): object =>
  Object.entries(object).reduce((a, [k, v]) => (v ? { ...a, [k]: v } : a), {})

// Get object value from keys path (eg: "key1.key2.key3")
export const getValueFromPath = (object: object, predicate?: string): any => {
  if (!predicate || typeof object !== 'object') return object

  return predicate.split('.').reduce((prev, curr) => (prev ? (prev as any)[curr] : null), object)
}
